var initializeBlockCarousel = function(block){
    
	var count = jQuery(".slick > *", block).length;
	var carousel = jQuery(".slick", block);
	const slidesToShow = carousel.data('columns');
	var showDots = count <= slidesToShow ? false : true;
	
    jQuery('.slick:not(.slick-initialized)', block).slick({  
		slidesToShow: slidesToShow,
		slidesToScroll: slidesToShow,
		rows: 1,
		slidesPerRow: 1,
		dots: showDots,
		arrows: true,
		autoplay: false,
		autoplaySpeed: 3000,
		fade: false,
		easing: "linear",
		pauseOnHover: false,
		infinite: false,
		draggable: false,
		swipe: true,
		adaptiveHeight: false, 
		responsive: [
		{
		  breakpoint: 680,
		  settings: {
			slidesToShow: 1,
			slidesToScroll: 1
		  }
		}
		]
	});
    
}

//initialize each block on front end
jQuery(document).ready(function(){
    jQuery('.wp-block-carousel').each(function(){
        initializeBlockCarousel(jQuery(this));
    });
});

//initialize dynamic block preview in the editor
if(window.acf)
    window.acf.addAction('render_block_preview/type=carousel', initializeBlockCarousel);
